const _ = "adyen-pe-summary-item", A = _ + "__label-container", L = A + "--loading", S = _ + "--body", o = _ + "__label", n = _ + "__placeholder", t = _ + "__amount";
export {
  t as AMOUNT_CLASS,
  _ as BASE_CLASS,
  S as BODY_CLASS,
  o as LABEL_CLASS,
  A as LABEL_CONTAINER_CLASS,
  L as LABEL_CONTAINER_CLASS_LOADING,
  n as PLACEHOLDER_CLASS
};
